const HTML_INPUT_DATE_PATTERN = 'HTML_INPUT';

function zeroPadded(num) {
    if (num < 10) {
        return '0' + num;
    }
    return '' + num;
}

function formatMonth(month) {
    return zeroPadded(month + 1);
}

function isOldIe() {
    const browser = Hop.getBrowserDesc();
    return browser && browser.msie && browser.version < 11;
}

function getLocale(options) {
    // must not be null, undefined is OK
    return options.locale || document.getElementsByTagName('html')[0].getAttribute('lang') || undefined;
}

function defaultTimeFormat(d, options) {
    const output = [];
    if (options.hour !== false) {
        output.push(zeroPadded(d.getHours()));
    }
    if (options.minute !== false) {
        output.push(zeroPadded(d.getMinutes()));
    }
    if (options.second !== false) {
        output.push(zeroPadded(d.getSeconds()));
    }
    return output.join(':');
}

function defaultDateFormat(d, options) {
    const output = [];
    if (options.day !== false) {
        output.push(zeroPadded(d.getDate()));
    }
    if (options.month !== false) {
        output.push(formatMonth(d.getMonth()));
    }
    if (options.year !== false) {
        output.push(d.getFullYear());
    }
    return output.join('/');
}

function htmlInputDateFormat(d) {
    const output = [];
    output.push(d.getFullYear());
    output.push(formatMonth(d.getMonth()));
    output.push(zeroPadded(d.getDate()));
    return output.join('-');
}

export function formatDate(date, userOptions) {
    if (date === null || date === '' || date === 0) {
        return '';
    }

    date = convertToDateIfString(date);

    const d = new Date(date);

    userOptions = userOptions || {};

    if (userOptions.pattern) {
        if (userOptions.pattern === HTML_INPUT_DATE_PATTERN) {
            return htmlInputDateFormat(d);
        }

        const supportedPattern = findSupportedPattern(userOptions.pattern);
        return supportedPattern.format(d);
    }

    const cleanOptions = {
        year: userOptions.year === false ? undefined : userOptions.year || 'numeric',
        month: userOptions.month === false ? undefined : userOptions.month || 'numeric',
        day: userOptions.day === false ? undefined : userOptions.day || 'numeric',
    };

    const locale = getLocale(userOptions);

    if (d.toLocaleDateString && !isOldIe()) {
        try {
            return d.toLocaleDateString(locale, cleanOptions);
        } catch (e) {
            if (e.name === 'RangeError') {
                // missing locale, switching to fallback
            } else {
                throw e;
            }
        }
    }

    return defaultDateFormat(d, userOptions);
}

export function formatTime(date, userOptions) {
    if (date === null || date === '' || date === 0) {
        return '';
    }

    const d = new Date(date);

    userOptions = userOptions || {};
    const cleanOptions = {
        hour: userOptions.hour === false ? undefined : userOptions.hour || 'numeric',
        minute: userOptions.minute === false ? undefined : userOptions.minute || 'numeric',
        second: userOptions.second === false ? undefined : userOptions.second || 'numeric',
    };

    const locale = getLocale(userOptions);

    if (d.toLocaleTimeString && !isOldIe()) {
        try {
            return d.toLocaleTimeString(locale, cleanOptions);
        } catch (e) {
            if (e.name === 'RangeError') {
                // missing locale, switching to fallback
            } else {
                throw e;
            }
        }
    }

    return defaultTimeFormat(d, userOptions);
}

function convertToDateIfString(str) {
    if (typeof str === 'string') {
        const date = new Date(str);
        // IE and old versions of Safari don't handle ISO format
        if (!isNaN(date) && !date.toString().includes('Invalid')) {
            return date;
        }

        const dateTimeRe = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})([-+])(\d{2})(\d{2})$/;
        let match = dateTimeRe.exec(str);
        if (match) {
            const utcDate = new Date(Date.UTC(match[1], match[2] - 1, match[3], match[4], match[5], match[6], match[7]));
            const sign = match[8] === '+' ? 1 : -1;
            const offsetInMinutes = match[9] * 60 + match[10];
            const offsetInMs = offsetInMinutes * 60 * 1000;
            utcDate.setTime(utcDate.getTime() + sign * offsetInMs);
            return utcDate;
        }

        const dateRe = /^(\d{4})-(\d{2})-(\d{2})$/;
        match = dateRe.exec(str);
        if (match) {
            return new Date(match[1], match[2] - 1, match[3]);
        }
    }

    return str;
}

export function formatDateTime(date, userOptions) {
    if (date === null || date === '' || date === 0) {
        return '';
    }

    const d = convertToDateIfString(date);

    userOptions = userOptions || {};
    const cleanOptions = {
        year: userOptions.year === false ? undefined : userOptions.year || 'numeric',
        month: userOptions.month === false ? undefined : userOptions.month || 'numeric',
        day: userOptions.day === false ? undefined : userOptions.day || 'numeric',
        hour: userOptions.hour === false ? undefined : userOptions.hour || 'numeric',
        minute: userOptions.minute === false ? undefined : userOptions.minute || 'numeric',
        second: userOptions.second === false ? undefined : userOptions.second || 'numeric',
    };

    const locale = getLocale(userOptions);

    if (d.toLocaleDateString && !isOldIe()) {
        try {
            return d.toLocaleDateString(locale, cleanOptions);
        } catch (e) {
            if (e.name === 'RangeError') {
                // missing locale, switching to fallback
            } else {
                throw e;
            }
        }
    }

    return defaultDateFormat(d, userOptions) + ' ' + defaultTimeFormat(d, userOptions);
}

export function toInputDate(date) {
    const day = zeroPadded(date.getDate());
    const month = zeroPadded(date.getMonth() + 1);
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
}

const SupportedPatterns = [
    {
        expression: /dd\/MM\/yyyy/,
        parseRegexp: /^(0[1-9]|1[0-9]|2[0-9]|3[01])\/(0[1-9]|1[012])\/([0-9]{4})$/,
        fct: (match) => new Date(match[3], parseInt(match[2]) - 1, match[1]),
        format: (d) => zeroPadded(d.getDate()) + '/' + zeroPadded(d.getMonth() + 1) + '/' + d.getFullYear(),
    },
    {
        expression: /d\/M\/yyyy/,
        parseRegexp: /^(0?[1-9]|1[0-9]|2[0-9]|3[01])\/(0?[1-9]|1[012])\/([0-9]{4})$/,
        fct: (match) => new Date(match[3], parseInt(match[2]) - 1, match[1]),
        format: (d) => d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear(),
    },
    {
        expression: /M\/d\/yyyy/,
        parseRegexp: /^(0?[1-9]|1[012])\/(0?[1-9]|1[0-9]|2[0-9]|3[01])\/([0-9]{4})$/,
        fct: (match) => new Date(match[3], parseInt(match[1]) - 1, match[2]),
        format: (d) => d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear(),
    },
    {
        expression: /dd\.MM\.yyyy/,
        parseRegexp: /^(0[1-9]|1[0-9]|2[0-9]|3[01])\.(0[1-9]|1[012])\.([0-9]{4})$/,
        fct: (match) => new Date(match[3], parseInt(match[2]) - 1, match[1]),
        format: (d) => zeroPadded(d.getDate()) + '.' + zeroPadded(d.getMonth() + 1) + '.' + d.getFullYear(),
    },
];

const findSupportedPattern = (pattern) => {
    if (!pattern) {
        throw new Error(`findSupportedPattern: no date pattern provided`);
    }
    for (const supportedPattern of SupportedPatterns) {
        const parsedPattern = pattern.match(supportedPattern.expression);
        if (parsedPattern) {
            return supportedPattern;
        }
    }
    throw new Error(`Invalid date pattern ${pattern}`);
};

export function parseDateFromPattern(dateString = '', pattern) {
    const datePattern = findSupportedPattern(pattern);
    const parsedInput = dateString.trim().match(datePattern.parseRegexp);

    if (parsedInput) {
        return datePattern.fct(parsedInput);
    }
    return new Date(NaN);
}

export function mixin(Hop) {
    Object.assign(Hop, {
        formatDate,
        formatDateTime,
        formatTime,
        toInputDate,
        mixin,
        parseDateFromPattern,
    });
}
